import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from "rxjs";
import { AuthError } from "../../models/auth-error";

@Component({
    selector: 'ft-request-link',
    templateUrl: './request-link.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestLinkComponent {
    @Input() isLinkSent = false;
    @Input() error: AuthError;
    @Input() loading$: Observable<boolean>;
    @Output() sendLink = new EventEmitter();

    constructor() {
    }

}
